export default __webpack_public_path__ + "static/media/whitening-new.cf8ef79a.png";